import React from 'react';

type BadgeVariant = 'published' | 'draft' | 'private' | 'generating' | 'failed' | 'free' | 'pro' | 'advanced' | 'success' | 'warning' | 'danger' | 'info';

interface StatusBadgeProps {
  variant: BadgeVariant;
  label?: string;
  size?: 'sm' | 'md';
}

const variantMap: Record<BadgeVariant, { bg: string; text: string; dot: string; defaultLabel: string }> = {
  published: { bg: 'bg-success/15', text: 'text-success', dot: 'bg-success', defaultLabel: 'Publicado' },
  draft: { bg: 'bg-warning/15', text: 'text-warning', dot: 'bg-warning', defaultLabel: 'Rascunho' },
  private: { bg: 'bg-muted', text: 'text-muted-foreground', dot: 'bg-muted-foreground', defaultLabel: 'Privado' },
  generating: { bg: 'bg-primary/15', text: 'text-primary', dot: 'bg-primary', defaultLabel: 'A Gerar' },
  failed: { bg: 'bg-danger/15', text: 'text-danger', dot: 'bg-danger', defaultLabel: 'Falhou' },
  free: { bg: 'bg-success/15', text: 'text-success', dot: 'bg-success', defaultLabel: 'Gratuito' },
  pro: { bg: 'bg-primary/15', text: 'text-primary', dot: 'bg-primary', defaultLabel: 'Pro' },
  advanced: { bg: 'bg-accent/15', text: 'text-accent', dot: 'bg-accent', defaultLabel: 'Advanced' },
  success: { bg: 'bg-success/15', text: 'text-success', dot: 'bg-success', defaultLabel: 'Sucesso' },
  warning: { bg: 'bg-warning/15', text: 'text-warning', dot: 'bg-warning', defaultLabel: 'Aviso' },
  danger: { bg: 'bg-danger/15', text: 'text-danger', dot: 'bg-danger', defaultLabel: 'Erro' },
  info: { bg: 'bg-accent/15', text: 'text-accent', dot: 'bg-accent', defaultLabel: 'Info' },
};

export default function StatusBadge({ variant, label, size = 'md' }: StatusBadgeProps) {
  const v = variantMap[variant];
  const sizeClasses = size === 'sm' ? 'text-xs px-2 py-0.5' : 'text-xs px-2.5 py-1';

  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full font-medium ${v.bg} ${v.text} ${sizeClasses}`}>
      <span className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${v.dot}`} />
      {label ?? v.defaultLabel}
    </span>
  );
}